import {
  Button,
  ButtonGroup,
  fieldKey,
  Fieldset,
  Form,
  TextInput,
  useControlled,
} from "@datapay-by-datacom/design-system";
import { OrgCategory } from "../../../generated/core-api";
import { useProvisionOrg } from "../../hooks";

interface OrgCreateFormProps {
  userId: string;
  category: OrgCategory;
  onSuccess: () => void;
}

export function OrgCreateForm({
  userId,
  category,
  onSuccess,
}: OrgCreateFormProps) {
  const field = useControlled({
    name: "",
    category,
    id: crypto.randomUUID().toString(),
    creator_user_id: userId,
  });

  const input = fieldKey(field);
  const create = useProvisionOrg();

  return (
    <Form
      onSubmit={(event) => {
        event.preventDefault();
        create.mutate(field.value, {
          onSuccess,
        });
      }}
    >
      <Fieldset>
        <TextInput
          label="Founding admin user id"
          isReadOnly
          value={userId}
          isRequired
        />

        <TextInput label="Id" {...input("id")} isRequired />

        <TextInput label="Name" {...input("name")} isRequired />

        <ButtonGroup align="right">
          <Button
            type="submit"
            isDisabled={create.isPending || !field.value.name}
          >
            {create.isPending ? "Provisioning..." : "Provision"}
          </Button>
        </ButtonGroup>
      </Fieldset>
    </Form>
  );
}
